import React, { Component } from 'react'
import { UserIsAuthenticated } from 'utils/RouteGuards'
import PropTypes from 'prop-types'
import { Icon, Segment, Form, Button, Container } from 'semantic-ui-react'
import { SemanticFormField } from 'components'
import { firebaseConnect } from 'react-redux-firebase'
import { connect } from 'react-redux'
import { replace } from 'react-router-redux'
import { formValueSelector, FieldArray, Field, reduxForm } from 'redux-form'
import { genderOptions, manufacturerOptions } from 'utils/Data'
import styled from 'styled-components'
import './styles.scss'

const Centered = styled.div`
  margin: auto;
  width: 50%;
`

const renderProduct = fields => (product, index) => {
  const { manufacturer, serial } = fields.get(index)

  return (
    <Form.Group key={index} widths='equal'>
      {manufacturer === 'notListed' ? (
        [
          <Field
            name={`${product}.manufacturerOverride`}
            component={SemanticFormField}
            as={Form.Input}
            type='text'
            placeholder='Hersteller'
            required
          />,
          <Button
            icon
            onClick={() => {
              fields.remove(index)
              fields.insert(index, { serial })
            }}
          >
            <Icon name='undo' />
          </Button>
        ]
      ) : (
        <Field
          name={`${product}.manufacturer`}
          component={SemanticFormField}
          as={Form.Select}
          options={manufacturerOptions}
          placeholder='Hersteller'
          required
        />
      )}
      <Field
        name={`${product}.serial`}
        component={SemanticFormField}
        as={Form.Input}
        type='text'
        placeholder='Seriennummer'
        required
      />
      <Field
        name={`${product}.model`}
        component={SemanticFormField}
        as={Form.Input}
        type='text'
        placeholder='Modellzeichnung'
        required
      />
      <div className='two wide field'>
        <Button
          fluid
          negative
          disabled={fields.length <= 1}
          icon
          onClick={() => fields.remove(index)}
        >
          <Icon name='trash' />
        </Button>
      </div>
    </Form.Group>
  )
}

const renderProducts = ({ fields }) => (
  <Segment>
    {fields.map(renderProduct(fields))}
    <Centered>
      <Button fluid color='blue' onClick={() => fields.push({})}>
        Produkt hinzufügen
      </Button>
    </Centered>
  </Segment>
)

renderProducts.propTypes = {
  fields: PropTypes.shape({
    push: PropTypes.func,
    remove: PropTypes.func
  })
}

const selector = formValueSelector('addCustomer')

@UserIsAuthenticated
@reduxForm({
  form: 'addCustomer',
  initialValues: {
    products: [{}]
  }
})
@firebaseConnect(['customers']) // add this.props.firebase
@connect(
  // map redux state to props
  state => ({
    warranty: selector(state, 'warranty')
  }),
  dispatch => ({
    navigateToPrint: id => dispatch(replace('/print', { id }))
  })
)
class AddCustomer extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired
  }

  state = {
    isLoading: false
  }

  submit = async customer => {
    const { firebase, navigateToPrint } = this.props
    this.setState({ isLoading: true })
    try {
      const { key } = await firebase.push('customers', {
        ...customer,
        purchaseDate: Date.now()
      })
      this.setState({ isLoading: false })
      navigateToPrint(key)
    } catch (e) {
      this.setState({ isLoading: false })
    }
  }

  render () {
    const { handleSubmit } = this.props
    const { isLoading } = this.state

    return (
      <Container>
        <Form
          loading={isLoading}
          size='large'
          name='login'
          onSubmit={handleSubmit(this.submit)}
        >
          <Field
            label='Firma'
            name='company'
            component={SemanticFormField}
            as={Form.Input}
            type='text'
            placeholder='Firma'
          />
          <Form.Group widths='equal'>
            <Field
              label='Anrede'
              name='title'
              component={SemanticFormField}
              as={Form.Select}
              options={genderOptions}
              placeholder='Anrede'
              required
            />
            <Field
              label='Name'
              name='name'
              component={SemanticFormField}
              as={Form.Input}
              type='text'
              placeholder='Name'
              required
            />
            <Field
              label='Vorname'
              name='firstName'
              component={SemanticFormField}
              as={Form.Input}
              type='text'
              placeholder='Vorname'
            />
          </Form.Group>
          <Field
            label='Straße'
            name='street'
            component={SemanticFormField}
            as={Form.Input}
            type='text'
            placeholder='Straße'
          />
          <Form.Group widths='equal'>
            <Field
              label='Postleitzahl'
              name='zipCode'
              component={SemanticFormField}
              as={Form.Input}
              type='number'
              placeholder='Postleitzahl'
              required
            />
            <Field
              label='Ort'
              name='city'
              component={SemanticFormField}
              as={Form.Input}
              type='text'
              placeholder='Ort'
            />
          </Form.Group>
          <Field
            name='email'
            label='E-Mail Adresse'
            component={SemanticFormField}
            as={Form.Input}
            type='email'
            placeholder='E-Mail Adresse'
            required
          />
          <FieldArray name='products' component={renderProducts} />
          <Field
            label='Verkäufernummer'
            name='vendorId'
            component={SemanticFormField}
            as={Form.Input}
            type='text'
            placeholder='Verkäufernummer'
            required
          />
          <Field
            label='Garantie-Erweiterung ausgewählt'
            name='warranty'
            component={SemanticFormField}
            as={Form.Checkbox}
          />
          <Field
            label='Ich möchte die Foto-Video Sauter Kundeninformation via E-Mail erhalten.'
            name='sendMail'
            component={SemanticFormField}
            as={Form.Checkbox}
          />
          <div style={{ height: 30 }} />
          <Button fluid size='large' primary type='submit'>
            Speichern
          </Button>
          <div style={{ height: 30 }} />
        </Form>
      </Container>
    )
  }
}

export default AddCustomer



// WEBPACK FOOTER //
// ./src/routes/AddCustomer/index.js